export default __webpack_public_path__ + "static/media/room-3.92fc5b83.jpg";